import { LayoutRegistered } from "layouts/LayoutHelper";
import RootLayout from "layouts";
import Loadable from "react-loadable";
import React from "react";
import Loading from "../components/common/viewers/loading";
import { getParams } from "../common";
import EmailConfirmation from "../components/user/email-confirmation";
import AgentConfirmation from "../components/user/AgentConfirmation";
import Frontend from "./front-end";

const LazyResetPassword = Loadable({
  loader: () => import("themes/cashrent/pages/reset-password"),
  loading: Loading,
});

const LazyLogin = Loadable({
  loader: () => import("themes/cashrent/pages/login"),
  loading: Loading,
});

const LazySignup = Loadable({
  loader: () => import("themes/cashrent/pages/signup"),
  loading: Loading,
});

const LazyInformation = Loadable({
  loader: () => import("themes/cashrent/pages/info-steps"),
  loading: Loading,
});

const FarmerSearchResult = Loadable({
  loader: () => import("themes/cashrent/pages/farmer-search-result"),
  loading: Loading,
});

const RequestFreeEstimate = Loadable({
  loader: () => import("themes/cashrent/pages/free-estimate"),
  loading: Loading,
});
const LazyVanityUrl = Loadable({
  loader: () => import("themes/cashrent/pages/vanity-urls"),
  loading: Loading,
});
const LazyFarmsDetail = Loadable({
  loader: () => import("themes/cashrent/pages/dashboard-farms-detail/FarmDetailsLayout"),
  loading: Loading,
});
const LazyListingCreate = Loadable({
  loader: () => import("themes/cashrent/pages/dashboard-listing-detail/CreateListing"),
  loading: Loading,
});

const LazyListingUpdate = Loadable({
  loader: () => import("themes/cashrent/pages/dashboard-listing-detail/UpdateListing"),
  loading: Loading,
});

const LazySignUpContact = Loadable({
  loader: () => import("themes/cashrent/pages/sign-up-contact/SignUpContact"),
  loading: Loading,
});

const LazyReviewContract = Loadable({
  loader: () => import("themes/cashrent/pages/review-contract/ReviewContract"),
  loading: Loading,
});

const LazySignContract = Loadable({
  loader: () => import("themes/cashrent/pages/sign-contract/SignContract"),
  loading: Loading,
});

const LazyLogout = Loadable({
  loader: () => import("themes/cashrent/pages/logout/Logout"),
  loading: Loading,
});

const ROOT = "";

export default [
  {
    component: RootLayout,
    routes: [
      {
        path: "/reset-password",
        exact: true,
        component: LazyResetPassword,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/login",
        exact: true,
        component: LazyLogin,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/logout",
        exact: true,
        component: LazyLogout,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: [
          `${ROOT}/register/:inviteCode`,
          `${ROOT}/register`,
        ],
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);
          return <LazySignup {...props} routeParams={routeParams}/>;
        },
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/information",
        exact: true,
        authenticated: true,
        component: LazyInformation,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/agritalk",
        exact: true,
        component: LazyVanityUrl,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/offer21",
        exact: true,
        component: LazyVanityUrl,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/plant21",
        exact: true,
        component: LazyVanityUrl,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/agritalk",
        exact: true,
        component: LazyVanityUrl,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/offer21",
        exact: true,
        component: LazyVanityUrl,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/plant21",
        exact: true,
        component: LazyVanityUrl,
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/email-confirmation/:token",
        component: (props) => {
          const routeParams = getParams(props);
          return <EmailConfirmation routeParams={routeParams} />;
        },
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/invitation/:id",
        component: (props) => {
          const routeParams = getParams(props);
          return <AgentConfirmation routeParams={routeParams} />;
        },
        layout: LayoutRegistered.defaultLayout,
      },
      {
        path: "/sign-up/:token",
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);
          return <LazySignUpContact {...props} routeParams={routeParams} />;
        },
         layout: LayoutRegistered.defaultLayout,
      },
      {
        path: [
          `${ROOT}/find-listing/:lng/:lat/:zoom(\\d+)`,
          `${ROOT}/find-listing/:lng/:lat/:address`,
          `${ROOT}/find-listing/:lng/:lat`,
          `${ROOT}/find-listing/:addresses`,
          `${ROOT}/find-listing`,
        ],
        exact: true,
        layout: LayoutRegistered.defaultLayout,
        component: (props) => {
          const routeParams = getParams(props);
          return <FarmerSearchResult {...props} routeParams={routeParams}/>;
        },
      },
      {
        path: [
          `${ROOT}/free-estimate`,
        ],
        layout: LayoutRegistered.defaultLayout,
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);
          return <RequestFreeEstimate {...props} routeParams={routeParams}/>;
        },
      },
      {
        path: [
          `${ROOT}/my-account/farms/new`,
        ],
        layout: LayoutRegistered.defaultLayout,
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);
          return <LazyFarmsDetail {...props} routeParams={routeParams}/>;
        },
      },
      {
        path: [
          `${ROOT}/listing/:landType/create`,
        ],
        layout: LayoutRegistered.defaultLayout,
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);
          const isAgricultural = routeParams.landType !== "hunting";

          return <LazyListingCreate isAgricultural={isAgricultural} {...props} routeParams={routeParams}/>;
        },
      },
      {
        path: [
          `${ROOT}/my-account/listing/:id/information`,
        ],
        layout: LayoutRegistered.defaultLayout,
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);

          return <LazyListingUpdate {...props} routeParams={routeParams}/>;
        },
      },
      {
        path: [
          `${ROOT}/my-account/bidding-review-agreement/:id`,
        ],
        layout: LayoutRegistered.defaultLayout,
        authenticated: true,
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);

          return <LazyReviewContract {...props} routeParams={routeParams}/>;
        },
      },
      {
        path: [
          `${ROOT}/my-account/bidding-sign-agreement/:id`,
        ],
        layout: LayoutRegistered.defaultLayout,
        authenticated: true,
        exact: true,
        component: (props) => {
          const routeParams = getParams(props);

          return <LazySignContract {...props} routeParams={routeParams}/>;
        },
      },
      { ...Frontend },
    ],
  },

];
